export {FeatureSliderVariant} from './lib/feature-slider-variant';